(function () {
  'use strict';

  function initPinFeature(section) {
    if (section.dataset.pfInit) return;
    section.dataset.pfInit = '1';

    var outer    = section.querySelector('[data-pin-outer]');
    var features = Array.from(section.querySelectorAll('[data-feature]'));
    var dots     = Array.from(section.querySelectorAll('[data-dot]'));
    var count    = features.length;
    if (!outer || count === 0) return;

    var currentIdx = -1;
    var sectionTop = 0;
    var mobileObs  = null;
    var rafId      = null;
    var tickN      = 0;

    function isMobile() { return window.innerWidth < 768; }

    function recalc() {
      sectionTop = outer.getBoundingClientRect().top + window.pageYOffset;
    }

    function activate(idx) {
      if (idx === currentIdx) return;
      currentIdx = idx;
      features.forEach(function (f, i) {
        f.classList.toggle('is-active', i === idx);
        f.classList.toggle('is-above',  i < idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function tick() {
      if (++tickN % 120 === 0) recalc();
      var scrolled = window.pageYOffset - sectionTop;
      var segment  = window.innerHeight;
      if (scrolled > -segment && scrolled < (count + 1) * segment) {
        activate(Math.max(0, Math.min(Math.floor(scrolled / segment), count - 1)));
      }
      rafId = requestAnimationFrame(tick);
    }

    function setupMobile() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      features.forEach(function (f) { f.classList.remove('is-active', 'is-above'); });
      if (!('IntersectionObserver' in window)) {
        features.forEach(function (f) { f.classList.add('is-active'); });
        return;
      }
      if (mobileObs) mobileObs.disconnect();
      mobileObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('is-active');
        });
      }, { threshold: 0.25 });
      features.forEach(function (f) { mobileObs.observe(f); });
    }

    function setupDesktop() {
      if (mobileObs) { mobileObs.disconnect(); mobileObs = null; }
      currentIdx = -1;
      recalc();
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);
    }

    function init() {
      recalc();
      if (isMobile()) { setupMobile(); } else { setupDesktop(); }
    }

    window.addEventListener('load', recalc);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 250);
    });

    init();
  }

  function scanAndInit() {
    document.querySelectorAll('.pin-feature').forEach(initPinFeature);
  }

  /* Run once on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  /* Watch for AJAX-injected sections (Lumia lazy loading) */
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('pin-feature')) {
          initPinFeature(node);
        }
        node.querySelectorAll && node.querySelectorAll('.pin-feature').forEach(initPinFeature);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
